import React, { useState } from 'react';
import './BackgroundColourInput.scss';
import { RgbaColor, RgbaColorPicker } from 'react-colorful';
import { useDebouncedCallback } from 'use-debounce';
import useProject from '../../../hooks/useProject';
import { useTranslation } from 'react-i18next';
import { isRgbaColor, stringToRgaColor, toTwoDigitHex } from '../../../helpers/colorHelper/colorHelper';
import Help from '../../Help/Help';

const BackgroundColourInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const debounce = 500;

  const debouncedRgbaColorChange = useDebouncedCallback(
    (color: RgbaColor | string) => {
      let value = '';
      let transparency;

      if (isRgbaColor(color)) {
        value = `#${toTwoDigitHex(color.r)}${toTwoDigitHex(color.g)}${toTwoDigitHex(color.b)}`;
        transparency = color.a;
      } else {
        value = color;
        transparency = 0.75;
      }

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          overlayBackgroundColour: value,
          overlayBackgroundTransparency: transparency,
        });
      } else {
        updateEncoder(project.encoder, {
          overlayBackgroundColour: value,
          overlayBackgroundTransparency: transparency,
        });
      }
    },

    debounce,
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [rgbaColor, setRgbaColor] = useState(
    stringToRgaColor(
      project.encoder.overlayBackgroundColour,
      project.encoder.overlayBackgroundTransparency,
    ),
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [fontColor, setFontColor] = useState(project.encoder.overlayBackgroundColour || '##000000');

  return (
    <div className="background-colour-input">
      <div className="input-title">
        {t('producer.inputs.background-colour.title')}
        <Help
          title="Background Colour"
          text="Allows you to adjust the background colour of the caption box.<br/><br/>You can also remove the background colour completely where the box is transparent.<br/><br/>Some amount of background colour can make the captions more accessible."
        />
      </div>
      <RgbaColorPicker color={rgbaColor} onChange={debouncedRgbaColorChange} />
    </div>
  );
};

export default React.memo(BackgroundColourInput);
